import React, { useEffect, useId, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { NavLink, useLocation } from "react-router-dom";

const SidebarMenu = ({ route }) => {
  const { pathname } = useLocation();
  const submenuId = useId();
  const hasActiveChild = route.subRoutes.some((child) => pathname === child.path || pathname.startsWith(`${child.path}/`));
  const [isMenuOpen, setIsMenuOpen] = useState(hasActiveChild);
  useEffect(() => { if (hasActiveChild) setIsMenuOpen(true); }, [hasActiveChild]);

  return (
    <>
      <button
        type="button"
        className={`menu${isMenuOpen ? " open" : ""}`}
        onClick={() => setIsMenuOpen((open) => !open)}
        aria-expanded={isMenuOpen}
        aria-controls={submenuId}
      >
        <span className="menu_item">
          <span className="icon" aria-hidden="true">{route.icon}</span>
          <span className="link-text">{route.name}</span>
        </span>
        <FiChevronDown className="menu-chevron" size={16} aria-hidden="true" />
      </button>
        <div id={submenuId} className="menu_container" hidden={!isMenuOpen}>
          {route.subRoutes.map((subRoute) => (
            <NavLink
              to={subRoute.path}
              key={subRoute.path}
              className={({ isActive }) => `link submenu-link${isActive ? " active" : ""}`}
            >
              <span className="icon" aria-hidden="true">{subRoute.icon}</span>
              <span className="link-text">{subRoute.name}</span>
            </NavLink>
          ))}
        </div>
    </>
  );
};

export default SidebarMenu;
